import React, { Component } from 'react';
import { connect } from "react-redux";
import { IRootState } from '../../../store';
import DispatchProps from '../../../utils/DispatchProps';
import CDBBlogViewer from '../../cdb-blog-viewer/CDBBlogViewer';

interface TeamsBlogsProps {

}

class TeamsBlogs extends Component<TeamsBlogsProps & DispatchProps, any> {
    static displayName = TeamsBlogs.name;

    constructor(props: TeamsBlogsProps & DispatchProps) {
        super(props);

        this.state = {

        }
    }

    async componentDidMount() {
    }

    // TODO: ?
    //<script src="https://res.cdn.office.net/teams-js/2.0.0/js/MicrosoftTeams.min.js" integrity="sha384-QtTBFeFlfRDZBfwHJHYQp7MdLJ2C3sfAEB1Qpy+YblvjavBye+q87TELpTnvlXw4"></script>
    //<script>
    //    microsoftTeams.app.initialize();
    //</script>

    render() {
        return <CDBBlogViewer />
    }
}

export default connect(
    (state: IRootState): TeamsBlogsProps => {
        return {

        };
    }
)(TeamsBlogs)